"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const numeral_1 = __importDefault(require("numeral"));
const numericWidget_style_1 = __importDefault(require("./numericWidget.style"));
const NumericWidget = ({ classes, value = '' }) => {
    const error = value && value < 0;
    return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-is-error": error }, { children: value !== null ? numeral_1.default(value).format('0,0.00') : '' }), void 0));
};
exports.default = react_jss_1.default(numericWidget_style_1.default)(NumericWidget);
//# sourceMappingURL=numericWidget.js.map